import { resolveWalletIconString } from "@layerswap/wallet-core";
export const resolveEVMWalletConnectorIcon = ({ connector, iconUrl }) => {
    return resolveWalletIconString({ id: connector, iconUrl });
};
